import { autoinject, LogManager, bindable } from 'aurelia-framework';
import { EntityController } from 'pages/entity/entity-controller';
import { ChildItemInfo } from 'data/entities/entities';
import { ChildItemInfoService } from 'data/service/child-item-info-service';
import { MetadataService } from 'data/service/meta-data-service';


@autoinject()
export class SupportTicketGrid {
	pageSettings = { pageSize: 10, pageSizeList: [5, 10, 20] };

	@bindable tasks: Array<ChildItemInfo>;
	logger = LogManager.getLogger('SupportTicketGrid');
  }

